import { useEffect, useState } from 'react'
import ReactTooltip from 'react-tooltip'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { ViewModalHeader } from './ViewModalHeader'
import { getNeigborId, getNeigborIdGlobal, getips, getipstenant } from '../request/request'
import { DemoModal } from '../../../../Modal_Demo/ViewModalDemo'

const API_URL = process.env.REACT_APP_API_URL

type Rol = {
    createdAt: string
    ctxrId: number
    id: number
    ipid: string
    local_address: string
    local_as: number
    peer_as: number
    router_id: string
    bgpfamily: any[]
    holdtime: number
    description?: string | null
    addPath?: number
}

type ID = undefined | null | number

const RTB_REGEX = /^rtb-[a-zA-Z0-9]+$/i;

export const EditNeighbor = (props: any) => {
    const { currentUser } = useAuth()
    const tenant = useAppSelector((state) => state.TenantSlice.id)

    // ID local para DemoModal
    const [ID, setID] = useState<ID>(undefined)

    // Estado del neighbor a editar
    const [Neigh, setNeigbor] = useState<Rol>({
        createdAt: '',
        ctxrId: 0,
        id: 0,
        ipid: '',
        local_address: '',
        local_as: 0,
        peer_as: 0,
        router_id: '',
        bgpfamily: [],
        holdtime: 3,
        description: null,
        addPath: 0,
    })

    // Para controlar checks de BGP families
    const [isCheckedVPNv4, setIsCheckedVPNv4] = useState(false)
    const [isCheckedUnicast, setIsCheckedUnicast] = useState(false)
    const [isCheckedIPv6Unicast, setIsCheckedIPv6Unicast] = useState(false)

    // Lista de IPs para la instancia que se está editando
    const [ipupdate, setipsupdate] = useState<any[]>([])

    // Loading
    const [loading, setLoading] = useState(false)
    const [loadingIps, setLoadingIps] = useState(false) // en caso de usarse, lo dejamos

    // Add tab state and routing table state at the top of the component
    const [activeTab, setActiveTab] = useState<'general' | 'ipv4'>('general')
    const [routingTableInput, setRoutingTableInput] = useState('')
    const [routingTables, setRoutingTables] = useState<{ id: string; persist: boolean }[]>([])

    // Add-Path options mapping
    const addPathOptions = [
        { value: 0, label: 'Disabled' },
        { value: 1, label: 'Send' },
        { value: 2, label: 'Receive' },
        { value: 3, label: 'Send/Receive' }
    ]

    // Add handler for adding a routing table
    const handleAddRoutingTable = () => {
        const trimmed = routingTableInput.trim()
        if (trimmed && !routingTables.some(rt => rt.id === trimmed)) {
            setRoutingTables([...routingTables, { id: trimmed, persist: true }])
            setRoutingTableInput('')
        }
    }
    // Handler for toggling persist and updating backend
    const handleTogglePersist = async (id: string) => {
        const updatedTables = routingTables.map(rt => rt.id === id ? { ...rt, persist: !rt.persist } : rt)
        setRoutingTables(updatedTables)
        // Send update to backend
        const actualizar = {
            ipid: Neigh.ipid,
            router_id: Neigh.router_id,
            local_address: Neigh.local_address,
            local_as: Number(Neigh.local_as),
            peer_as: Number(Neigh.peer_as),
            bgpfamily: Neigh.bgpfamily,
            holdtime: Neigh.holdtime,
            description: Neigh.description ?? '',
            addPath: Neigh.addPath ?? 0,
            routingTables: updatedTables.map(rt => ({
                routing_table: rt.id,
                persist: rt.persist,
            })),
        }
        console.log('EditNeighbor - handleTogglePersist - Payload:', JSON.stringify(actualizar, null, 2))
        console.log('EditNeighbor - handleTogglePersist - Toggling persist for routing table:', id)
        try {
            if (tenant === 0) {
                await axios.put(API_URL + '/v1/ctxr/updateconfigbgpneighbor/' + props.uuid + '/' + props.id, actualizar)
            } else {
                await axios.put(
                    API_URL +
                    '/v1/ctxr/updateconfigbgpneighbor/' +
                    props.uuid +
                    '/' +
                    props.id +
                    '?tenantId=' +
                    tenant,
                    actualizar
                )
            }
            Swal.fire({
                icon: 'success',
                title: 'Routing table updated',
                timer: 1200,
                showConfirmButton: false,
            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to update routing tables',
            })
        }
    }
    // Handler for removing a routing table and updating backend
    const handleRemoveRoutingTable = async (id: string) => {
        const updatedTables = routingTables.filter(rt => rt.id !== id)
        setRoutingTables(updatedTables)
        // Send update to backend
        const actualizar = {
            ipid: Neigh.ipid,
            router_id: Neigh.router_id,
            local_address: Neigh.local_address,
            local_as: Number(Neigh.local_as),
            peer_as: Number(Neigh.peer_as),
            bgpfamily: Neigh.bgpfamily,
            holdtime: Neigh.holdtime,
            description: Neigh.description ?? '',
            addPath: Neigh.addPath ?? 0,
            routingTables: updatedTables.map(rt => ({
                routing_table: rt.id,
                persist: rt.persist,
            })),
        }
        console.log('EditNeighbor - handleRemoveRoutingTable - Payload:', JSON.stringify(actualizar, null, 2))
        console.log('EditNeighbor - handleRemoveRoutingTable - Removing routing table:', id)
        try {
            if (tenant === 0) {
                await axios.put(API_URL + '/v1/ctxr/updateconfigbgpneighbor/' + props.uuid + '/' + props.id, actualizar)
            } else {
                await axios.put(
                    API_URL +
                    '/v1/ctxr/updateconfigbgpneighbor/' +
                    props.uuid +
                    '/' +
                    props.id +
                    '?tenantId=' +
                    tenant,
                    actualizar
                )
            }
            Swal.fire({
                icon: 'success',
                title: 'Routing table removed and updated',
                timer: 1200,
                showConfirmButton: false,
            })
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to update routing tables',
            })
        }
    }
    // Allow Enter key to add routing table
    const handleRoutingTableInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleAddRoutingTable()
        }
    }

    useEffect(() => {
        document.body.classList.add('modal-open')
        return () => {
            document.body.classList.remove('modal-open')
        }
    }, [])

    // Al montar, si tenemos un props.id, cargamos sus datos
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (props.id !== '' && props.id !== null) {
                    let UserResponse;
                    if (tenant === 0) {
                        UserResponse = await getNeigborId(props.uuid, props.id);
                    } else {
                        UserResponse = await getNeigborIdGlobal(props.uuid, props.id, tenant);
                    }
                    
                    console.log('EditNeighbor - Data received from backend:', UserResponse.data);
                    console.log('EditNeighbor - addPath value from backend:', UserResponse.data.addPath, 'or add_path:', UserResponse.data.add_path);
                    
                    // Map addPath - handle both camelCase and snake_case from backend
                    const addPathValue = UserResponse.data.addPath ?? UserResponse.data.add_path ?? 0;
                    
                    setNeigbor({
                        ...UserResponse.data,
                        addPath: addPathValue
                    });

                    // Map routingTables from backend to local state
                    if (UserResponse.data.routingTables) {
                        setRoutingTables(
                            UserResponse.data.routingTables.map((rt: any) => ({
                                id: rt.routing_table,
                                persist: rt.persist
                            }))
                        );
                    } else {
                        setRoutingTables([]);
                    }
                }
            } catch (error) {
                console.error('Error loading neighbor data', error);
            }
        }
        fetchData()
    }, [props.id, props.uuid, tenant])

    // Sincronizar checkboxes con las bgpfamily del neighbor
    useEffect(() => {
        setIsCheckedVPNv4(Neigh.bgpfamily.includes('ipv4 mpls-vpn'))
        setIsCheckedUnicast(Neigh.bgpfamily.includes('ipv4 unicast'))
        setIsCheckedIPv6Unicast(Neigh.bgpfamily.includes('ipv6 unicast'))
    }, [Neigh.bgpfamily])

    // Cargar las IPs correspondientes a la instancia 'props.uuid'
    useEffect(() => {
        const fetchData = async () => {
            try {
                if (props.uuid) {
                    if (tenant === 0) {
                        const UserResponse = await getips(props.uuid)
                        setipsupdate(UserResponse.data)
                    } else {
                        const UserResponse = await getipstenant(props.uuid, tenant)
                        setipsupdate(UserResponse.data)
                    }
                }
            } catch (error) {
                console.error('Error loading IP list for edit', error)
            }
        }
        fetchData()
    }, [props.uuid, tenant])

    // Submit para actualizar
    const handleSubmit = async (e: any) => {
        e.preventDefault()
        setLoading(true)

        try {
            // Solo actualizamos si props.id NO es null
            if (props.id !== null) {
                // Validation checks using mapping
                const validations = [
                    { 
                        condition: Neigh.ipid === Neigh.router_id, 
                        title: 'Validation Error',
                        text: 'Neighbor IP and Router ID cannot have the same value'
                    }
                ]

                const failedValidation = validations.find(validation => validation.condition)
                if (failedValidation) {
                    setLoading(false)
                    Swal.fire({ 
                        icon: 'error', 
                        title: failedValidation.title,
                        text: failedValidation.text || ''
                    })
                    return
                }

                const actualizar = {
                    ipid: Neigh.ipid,
                    router_id: Neigh.router_id,
                    local_address: Neigh.local_address,
                    local_as: Number(Neigh.local_as),
                    peer_as: Number(Neigh.peer_as),
                    bgpfamily: Neigh.bgpfamily,
                    holdtime: Neigh.holdtime,
                    description: Neigh.description ?? '',
                    addPath: Neigh.addPath ?? 0,
                    routingTables: routingTables.map(rt => ({
                        routing_table: rt.id,
                        persist: rt.persist,
                    })),
                }
                console.log('EditNeighbor - Payload being sent to backend:', JSON.stringify(actualizar, null, 2))
                console.log('EditNeighbor - Tenant ID:', tenant)
                console.log('EditNeighbor - Device ID (UUID):', props.uuid)
                console.log('EditNeighbor - Neighbor ID:', props.id)

                if (tenant === 0) {
                    await axios
                        .put(API_URL + '/v1/ctxr/updateconfigbgpneighbor/' + props.uuid + '/' + props.id, actualizar)
                        .then(() => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Your Neighbor has Update',
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            props.setID(undefined)
                            axios.get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + props.uuid).then((res) => {
                                props.setRecords(res.data)
                            })
                            setTimeout(() => {
                                setLoading(false)
                            }, 1500)
                        })
                        .catch(() => {
                            setLoading(false)
                        })
                } else {
                    await axios
                        .put(
                            API_URL +
                            '/v1/ctxr/updateconfigbgpneighbor/' +
                            props.uuid +
                            '/' +
                            props.id +
                            '?tenantId=' +
                            tenant,
                            actualizar
                        )
                        .then(() => {
                            Swal.fire({
                                position: 'center',
                                icon: 'success',
                                title: 'Your Neighbor has Update',
                                showConfirmButton: false,
                                timer: 1500,
                            })
                            props.setID(undefined)
                            axios
                                .get(API_URL + '/v1/ctxr/listconfigbgpneighbor/' + props.uuid + '?tenantId=' + tenant)
                                .then((res) => {
                                    props.setRecords(res.data)
                                })
                            setTimeout(() => {
                                setLoading(false)
                            }, 1500)
                        })
                        .catch(() => {
                            setLoading(false)
                        })
                }
            }
        } catch (error: any) {
            console.log(error)
            setLoading(false)
        }
    }

    // Handler for saving all routing table changes from the IPv4 tab
    const handleSaveRoutingTablesTab = async () => {
        const actualizar = {
            ipid: Neigh.ipid,
            router_id: Neigh.router_id,
            local_address: Neigh.local_address,
            local_as: Number(Neigh.local_as),
            peer_as: Number(Neigh.peer_as),
            bgpfamily: Neigh.bgpfamily,
            holdtime: Neigh.holdtime,
            description: Neigh.description ?? '',
            addPath: Neigh.addPath ?? 0,
            routingTables: routingTables.map(rt => ({
                routing_table: rt.id,
                persist: rt.persist,
            })),
        }
        console.log('EditNeighbor - handleSaveRoutingTablesTab - Payload:', JSON.stringify(actualizar, null, 2))
        try {
            if (tenant === 0) {
                await axios.put(API_URL + '/v1/ctxr/updateconfigbgpneighbor/' + props.uuid + '/' + props.id, actualizar)
            } else {
                await axios.put(
                    API_URL +
                    '/v1/ctxr/updateconfigbgpneighbor/' +
                    props.uuid +
                    '/' +
                    props.id +
                    '?tenantId=' +
                    tenant,
                    actualizar
                )
            }
            Swal.fire({
                icon: 'success',
                title: 'Routing tables updated',
                timer: 1200,
                showConfirmButton: false,
            })
            setTimeout(() => {
                props.setID(undefined)
            }, 1200)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Failed to update routing tables',
            })
        }
    }

    return (
        <>
            <div className="modal fade show d-block" role="dialog" tabIndex={-1} aria-modal="true">
                <div className="modal-dialog modal-dialog-centered mw-650px">
                    <div className="modal-content">
                        <ViewModalHeader setID={props.setID} />
                        <div className="modal-body scroll-y mx-5">
                            {/* Tab Navigation */}
                            <div style={{ display: 'flex', borderBottom: '1px solid #eee', marginBottom: 24 }}>
                                <button
                                    type="button"
                                    className={`btn f-parrafo ${activeTab === 'general' ? 'btn-light-marino' : 'btn-light'}`}
                                    style={{ borderRadius: '8px 8px 0 0', marginRight: 8, fontWeight: 600, border: 'none', borderBottom: activeTab === 'general' ? '2px solid #FF4089' : 'none' }}
                                    onClick={() => setActiveTab('general')}
                                >
                                    General
                                </button>
                                <button
                                    type="button"
                                    className={`btn f-parrafo ${activeTab === 'ipv4' ? 'btn-light-marino' : 'btn-light'}`}
                                    style={{ borderRadius: '8px 8px 0 0', fontWeight: 600, border: 'none', borderBottom: activeTab === 'ipv4' ? '2px solid #FF4089' : 'none' }}
                                    onClick={() => setActiveTab('ipv4')}
                                >
                                    IPv4 Unicast Inbound
                                </button>
                            </div>
                            {/* Tab Content */}
                            {activeTab === 'general' && (
                                <div className="modal-body scroll-y mx-5">
                                    <form className="form w-100" onSubmit={handleSubmit}>
                                        <div className="text-center mb-5">
                                            <h1 className="text-marino fw-bolder mb-3 f-titulo fs-md">Edit Neighbor</h1>
                                        </div>

                                        {/* Neighbor IP */}
                                        <div className="row">
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Neighbor IP
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.ipid}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, ipid: e.target.value })}
                                                />
                                            </div>
                                            {/* Router ID */}
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Router ID
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.router_id}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, router_id: e.target.value })}
                                                />
                                            </div>
                                            {/* Local Address */}
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Local Address
                                                </label>
                                                <select
                                                    className="form-select text-center border border-gray-300 f-parrafo"
                                                    value={Neigh.local_address}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, local_address: e.target.value })}
                                                >
                                                    {ipupdate?.length === 0 && (
                                                        <option disabled selected hidden>
                                                            No data
                                                        </option>
                                                    )}
                                                    <option disabled selected hidden value={0}>
                                                        Select a IP
                                                    </option>
                                                    {ipupdate.map((ips: any, x: number) => (
                                                        <option key={x} value={ips.value}>
                                                            {ips.value}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="row" style={{ marginTop: '10px' }}>
                                            {/* Local AS */}
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Local AS
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.local_as}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, local_as: e.target.value })}
                                                />
                                            </div>
                                            {/* Peer AS */}
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Peer AS
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.peer_as}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, peer_as: e.target.value })}
                                                />
                                            </div>
                                            {/* Hold Time */}
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Hold Time
                                                </label>
                                                <i
                                                    className="fas fa-exclamation-circle ms-2 fs-7"
                                                    data-tip="The keep-alive period will correspond to one-third of the hold time."
                                                    data-for="holdTimeTooltip"
                                                ></i>
                                                <ReactTooltip id="holdTimeTooltip" place="top" effect="solid" />
                                                <input
                                                    type="number"
                                                    min={3}
                                                    max={65535}
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.holdtime}
                                                    onChange={(e: any) => setNeigbor({ ...Neigh, holdtime: e.target.value })}
                                                    onInput={(e: React.FormEvent<HTMLInputElement>) => {
                                                        const inputValue = e.currentTarget.value
                                                        const lastChar = inputValue[inputValue.length - 1]
                                                        if (isNaN(parseInt(lastChar, 10))) {
                                                            // si es string, recortar
                                                            const fix = parseInt(inputValue.slice(0, -1))
                                                            setNeigbor({ ...Neigh, holdtime: fix })
                                                        } else {
                                                            setNeigbor({ ...Neigh, holdtime: parseInt(inputValue) })
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <div className="row" style={{ marginTop: '20px' }}>
                                            <div className="col">
                                                <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                    value={Neigh.description ?? ''}
                                                    onChange={(e) => setNeigbor({ ...Neigh, description: e.target.value })}
                                                />
                                            </div>
                                        </div>

                                        {/* BGP Families */}
                                        <div className="mb-10">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-3 f-parrafo">
                                                BGP Families
                                            </label>
                                            <i
                                                className="fas fa-exclamation-circle ms-2 fs-7"
                                                data-bs-toggle="tooltip"
                                                title="Please select at least one BGP family."
                                            ></i>
                                            {/* VPNv4 */}
                                            <div className="form-check form-check-custom form-check-solid mb-2">
                                                <input
                                                    className="form-check-input border border-azul"
                                                    type="checkbox"
                                                    value="ipv4 mpls-vpn"
                                                    onChange={(e) => {
                                                        setIsCheckedVPNv4(e.target.checked)
                                                        setNeigbor({
                                                            ...Neigh,
                                                            bgpfamily: e.target.checked
                                                                ? [...Neigh.bgpfamily, 'ipv4 mpls-vpn']
                                                                : Neigh.bgpfamily.filter(
                                                                    (val: any) => val !== 'ipv4 mpls-vpn'
                                                                ),
                                                        })
                                                    }}
                                                    checked={isCheckedVPNv4}
                                                />
                                                <label className="form-check-label f-parrafo text-marino">
                                                    VPNv4
                                                </label>
                                            </div>
                                            {/* IPv4 Unicast */}
                                            <div className="form-check form-check-custom form-check-solid mb-2">
                                                <input
                                                    className="form-check-input border border-azul"
                                                    type="checkbox"
                                                    value="ipv4 unicast"
                                                    onChange={(e) => {
                                                        setIsCheckedUnicast(e.target.checked)
                                                        setNeigbor({
                                                            ...Neigh,
                                                            bgpfamily: e.target.checked
                                                                ? [...Neigh.bgpfamily, 'ipv4 unicast']
                                                                : Neigh.bgpfamily.filter(
                                                                    (val: any) => val !== 'ipv4 unicast'
                                                                ),
                                                        })
                                                    }}
                                                    checked={isCheckedUnicast}
                                                />
                                                <label className="form-check-label f-parrafo text-marino">
                                                    IPv4 Unicast
                                                </label>
                                            </div>

                                            <div className="form-check form-check-custom form-check-solid">
                                                <input
                                                    className="form-check-input border border-azul"
                                                    type="checkbox"
                                                    value="ipv6 unicast"
                                                    onChange={(e) => {
                                                        setIsCheckedIPv6Unicast(e.target.checked)
                                                        setNeigbor({
                                                            ...Neigh,
                                                            bgpfamily: e.target.checked
                                                                ? [...Neigh.bgpfamily, 'ipv6 unicast']
                                                                : Neigh.bgpfamily.filter(
                                                                    (val: any) => val !== 'ipv6 unicast'
                                                                ),
                                                        })
                                                    }}
                                                    checked={isCheckedIPv6Unicast}
                                                />
                                                <label className="form-check-label f-parrafo text-marino">
                                                    IPv6 Unicast
                                                </label>
                                            </div>
                                        </div>

                                        {/* Capabilities - Add-Path */}
                                        <div className="mb-10">
                                            <label className="form-label fw-bolder text-dark fs-6 mb-2 f-parrafo">
                                                Capabilities
                                            </label>
                                            <div className="text-muted f-parrafo" style={{ fontSize: '1.1em', marginBottom: 12 }}>
                                                <span className="text-marino fw-bolder">Add-Path</span>
                                            </div>
                                            <div className="d-flex gap-2 flex-wrap">
                                                {addPathOptions.map((option) => (
                                                    <button
                                                        key={option.value}
                                                        type="button"
                                                        className={`btn f-parrafo ${(Neigh.addPath ?? 0) === option.value ? 'btn-primary' : 'btn-light'}`}
                                                        style={{
                                                            minWidth: '80px',
                                                            padding: '6px 12px',
                                                            fontWeight: 600,
                                                            border: (Neigh.addPath ?? 0) === option.value ? 'none' : '1px solid #e4e6ef',
                                                            transition: 'none',
                                                            transform: 'none'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'none'}
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'none'}
                                                        onClick={() => setNeigbor({ ...Neigh, addPath: option.value })}
                                                    >
                                                        {option.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Botones */}
                                        {currentUser?.is_demo !== true && (
                                            <div className="d-grid mb-10 justify-content-center">
                                                <div className="row">
                                                    <div className="col">
                                                        <button
                                                            type="submit"
                                                            id="kt_sign_in_submit"
                                                            className="btn btn-primary"
                                                            style={{
                                                                opacity: loadingIps ? 0.5 : 1,
                                                                pointerEvents: loadingIps ? 'none' : 'auto',
                                                            }}
                                                            disabled={loadingIps}
                                                        >
                                                            {!loadingIps && <span className="indicator-label">Save</span>}
                                                            {loadingIps && (
                                                                <span className="indicator-progress" style={{ display: 'block' }}>
                                                                    Please wait...
                                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                                </span>
                                                            )}
                                                        </button>
                                                    </div>
                                                    <div className="col">
                                                        <button
                                                            className="btn border border-pink text-pink f-parrafo"
                                                            style={{ width: '200px' }}
                                                            onClick={() => props.setID(undefined)}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        {currentUser?.is_demo === true && (
                                            <div className="d-flex justify-content-center">
                                                <button onClick={() => setID(null)} type="submit">
                                                    Add
                                                </button>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            )}
                            {activeTab === 'ipv4' && (
                                <div>
                                    <div className="mb-4">
                                        <label className="form-label fw-bolder text-dark fs-6 mb-0 f-parrafo">
                                            Routing Table ID
                                        </label>
                                        <div className="text-muted f-parrafo" style={{ fontSize: '0.95em', marginBottom: 8 }}>
                                            Add AWS routing table IDs (e.g., rtb-xxxxxxxxxxxxxxxxx).
                                        </div>
                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                className="form-control form-control-solid border border-gray-300 f-parrafo"
                                                placeholder="rtb-..."
                                                value={routingTableInput}
                                                onChange={e => setRoutingTableInput(e.target.value)}
                                                onKeyDown={handleRoutingTableInputKeyDown}
                                                style={{ maxWidth: 300 }}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-primary"
                                                style={{ minWidth: 80 }}
                                                onClick={handleAddRoutingTable}
                                                disabled={!routingTableInput.trim() || !RTB_REGEX.test(routingTableInput.trim())}
                                            >
                                                Add
                                            </button>
                                        </div>
                                        {routingTableInput && !RTB_REGEX.test(routingTableInput.trim()) && (
                                            <div className="text-danger" style={{ fontSize: '0.9em' }}>
                                                Routing Table ID must start with "rtb-" and be followed by letters or numbers.
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-4">
                                        <div className="row fw-bold f-parrafo" style={{ borderBottom: '1px solid #eee', paddingBottom: 8, marginBottom: 8 }}>
                                            <div className="col">Routing Table ID</div>
                                            <div className="col-auto">Persist Upon BGP State</div>
                                            <div className="col-auto"></div>
                                        </div>
                                        {routingTables.length === 0 && (
                                            <div className="text-muted f-parrafo" style={{ fontSize: '0.95em' }}>
                                                No routing table IDs added.
                                            </div>
                                        )}
                                        {routingTables.map(rt => (
                                            <div className="row align-items-center mb-2" key={rt.id} style={{ background: '#fafbfc', borderRadius: 6, padding: 8 }}>
                                                <div className="col" style={{ wordBreak: 'break-all' }}>{rt.id}</div>
                                                <div className="col-auto">
                                                    <label className="form-switch">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={rt.persist}
                                                            onChange={() => handleTogglePersist(rt.id)}
                                                        />
                                                        <span className="form-check-label" style={{ marginLeft: 8 }}></span>
                                                    </label>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-light-danger"
                                                        onClick={() => handleRemoveRoutingTable(rt.id)}
                                                        style={{ borderRadius: '50%', width: 32, height: 32, padding: 0 }}
                                                    >
                                                        <span style={{ fontSize: 18, fontWeight: 700 }}>&times;</span>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="d-flex justify-content-end gap-3 mt-4">
                                        <button
                                            className="btn border border-pink text-pink f-parrafo"
                                            style={{ minWidth: 120 }}
                                            onClick={() => props.setID(undefined)}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            className="btn btn-primary f-parrafo"
                                            style={{ minWidth: 120 }}
                                            onClick={handleSaveRoutingTablesTab}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>

            {/* DemoModal en caso de que ID sea distinto de undefined */}
            {ID !== undefined && <DemoModal setID={setID} id={ID} />}
        </>
    )
}
